interface LogoProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
}

const Logo = ({ className = '', size = 'md' }: LogoProps) => {
  const sizeClasses = {
    sm: 'h-8',
    md: 'h-12',
    lg: 'h-16',
    xl: 'h-20',
  };

  return (
    <img
      src="/favicon.ico"
      alt="Church Hub - Engage. Encourage. Evangelize."
      className={`${sizeClasses[size]} ${className}`}
    />
  );
};

export default Logo;